// extracted by mini-css-extract-plugin
export default {"ViewSwitch":"styles_ViewSwitch__-cMGE","active":"styles_active__+zfrH","list":"styles_list__q3aDm","grid":"styles_grid__hAmK8"};